export default __webpack_public_path__ + "static/media/02.09.040.5920df28.png";